export default {
      id: "RUB-usage",
      viewBox: "0 0 473 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#RUB",
      toString: function () {
        return this.url;
      }
    }